import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from 'ui-components/components/flex';

import { cleanLocationString } from '../helpers';

export const AddressLine = ({ line }) => {
  const cleanLine = cleanLocationString(line);
  if (!cleanLine) {
    return null;
  }
  return <FlexRow>{cleanLine}</FlexRow>;
};

AddressLine.propTypes = {
  line: PropTypes.string,
};
